import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  Event as RouterEvent,
  RouterOutlet,
} from '@angular/router';
import { ConnectivityService } from './core/services/connectivity/connectivity.service';
import { TranslationService } from './core/services/translate/translation.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnDestroy, OnInit {
  public showOverlay = true;

  public readonly translationService = inject(TranslationService);
  private readonly connectivityService = inject(ConnectivityService);
  private readonly router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private readonly cdRef = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.navigationListener();
  }
  navigationListener() {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (event: RouterEvent) => {
        this.navigationInterceptor(event);
      },
    });
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.showOverlay = true;
      this.cdRef.detectChanges();
    }
    if (event instanceof NavigationEnd) {
      this.showOverlay = false;
      this.cdRef.detectChanges();
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.showOverlay = false;
      this.cdRef.detectChanges();
    }
    if (event instanceof NavigationError) {
      this.showOverlay = false;
      this.cdRef.detectChanges();
    }
  }

  ngOnDestroy() {
    this.connectivityService.stopChecking();
  }
}
